const INTEGER_FORMAT = new Intl.NumberFormat("pt-BR", { maximumFractionDigits: 0 });
const DECIMAL_FORMAT = new Intl.NumberFormat("pt-BR", { maximumFractionDigits: 2 });
const PERCENT_FORMAT = new Intl.NumberFormat("pt-BR", { maximumFractionDigits: 1 });

/** "12.480". */
export function formatInteger(value: number): string {
  return INTEGER_FORMAT.format(value);
}

/** "0,75", "1.200". */
export function formatDecimal(value: number): string {
  return DECIMAL_FORMAT.format(value);
}

/** Fração de 0 a 1 como porcentagem: 0.053 vira "5,3%". */
export function formatRatioPercent(ratio: number): string {
  return `${PERCENT_FORMAT.format(ratio * 100)}%`;
}

/**
 * Valor em dólar (custo de IA estimado pela tabela de preços, não fatura).
 * Abaixo de US$ 1 mostra até 4 casas para não virar "US$ 0,00".
 */
export function formatUsd(value: number): string {
  const fractionDigits = Math.abs(value) > 0 && Math.abs(value) < 1 ? 4 : 2;
  const formatted = new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: fractionDigits,
  }).format(value);
  return `US$ ${formatted}`;
}

/** "850 ms", "12 s", "3 min 5 s", "1 h 2 min". */
export function formatDurationMs(milliseconds: number): string {
  if (milliseconds < 1000) return `${Math.round(milliseconds)} ms`;
  const totalSeconds = Math.round(milliseconds / 1000);
  if (totalSeconds < 60) return `${totalSeconds} s`;
  const totalMinutes = Math.floor(totalSeconds / 60);
  if (totalMinutes < 60) {
    const seconds = totalSeconds % 60;
    return seconds ? `${totalMinutes} min ${seconds} s` : `${totalMinutes} min`;
  }
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return minutes ? `${hours} h ${minutes} min` : `${hours} h`;
}
